import { ImageModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class ImageODataRepo extends BaseODataRepository<ImageModel> {
  protected baseUrl = `/OData/images`;
}

export default ImageODataRepo;
